import { render } from "./CompletePage.vue?vue&type=template&id=4d0d8c96&scoped=true"
import script from "./CompletePage.vue?vue&type=script&lang=js"
export * from "./CompletePage.vue?vue&type=script&lang=js"

import "./CompletePage.vue?vue&type=style&index=0&id=4d0d8c96&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4d0d8c96"

export default script